module.exports = __webpack_public_path__ + "static/media/headlesskit-card.8b467b0f.png";